import type { TileData } from "../../models/worldState.ts";

export function revealTile(tile: TileData): TileData {
  if (tile.visibility === "revealed") {
    return tile;
  }

  return { ...tile, visibility: "revealed" };
}
